export default "__VITE_ASSET__C_KBC_nE__"